import React from 'react';
import Modal from 'react-responsive-modal';
import {Flex, SVGButton} from '/app/src/component';
import AutomessageUpgrade from './AutomessageUpgrade'
import StatisticsUpgrade from './StatisticsUpgrade'
import FileSizeUpgrade from './FileSizeUpgrade'
import HelpdeskUpgrade from './HelpdeskUpgrade'

const upgradeBtnStyle = {
    color: "JibberPurple_M",
    marginLeft: "10px"
}

const backBtnStyle = {
    marginRight: "10px"
}

const modalContainer = {
    width: "720px"
}


/*
    Upgrade modal factory: the contentType returns what should returned.
*/
const UpgradeModal = ({contentType, open, onClose, onClick}) => {
    let content = null
    switch(contentType) {
        case "automessage":
            content = <AutomessageUpgrade/>
            break
        case "stats":
            content = <StatisticsUpgrade/>
            break
        case "filesize":
            content = <FileSizeUpgrade
                text="Din nuvarande prisplan (Start) har en maxgräns på 30MB. Genom att uppgradera till Pro så kan du skicka filer med en storlek upp till 100MB!"/>
            break
        case "filesizePro":
            content = <FileSizeUpgrade text="Filstorleken är för stor (max: 100MB)." />
            break
        case "helpdesk":
            content = <HelpdeskUpgrade/>
            break
        default:
            content = ""
    }
    return (
        <Modal
            open={open}
            onClose={onClose}
            styles={{
                modal: {
                    borderRadius: '20px'
                }
            }}>
            <Flex {...modalContainer} column>
                {content}
                <Flex hAlignContent="center">
                    <SVGButton {...backBtnStyle}
                        text='Tillbaka'
                        color='DarkGray' border
                        src='/images/Return.svg'
                        onClick={onClose}/>
                    <SVGButton {...upgradeBtnStyle}
                        text='Uppgradera'
                        color='JibberPurple_M' border
                        src='/images/ArrowDirection_Right_S.svg'
                        iconPos='right'
                        onClick={onClick}/>
                </Flex>
            </Flex>
        </Modal>
    )
}

export default UpgradeModal;



// WEBPACK FOOTER //
// ./src/component/Modal/UpgradeModal/index.js